import * as React from 'react';
import { IgcThemeProviderComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A theme provider component that uses Lit context to provide theme information
 * to descendant components.
 *
 * This component allows you to scope a theme to a specific part of the page.
 * All library components within this provider will use the specified theme
 * instead of the global theme.
 * @slot  - Default slot for content that should receive the provided theme.
 * @class
 */
export const IgrThemeProvider = /* @__PURE__ */ createComponent({
  tagName: 'igc-theme-provider',
  displayName: 'IgrThemeProvider',
  elementClass: Component,
  react: React,
});

export type IgrThemeProvider = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrThemeProviderModule = Component;
